<template>
  <div>
    <vs-card class="cardx">
      <div slot="header" style="padding:10px;height: 100%;width:100%;display:flex;align-items: center;">
        <feather-icon @click="$router.go(-1)" icon="ArrowLeftIcon"  class="cursor-pointer navbar-fuzzy-search mr-4" />
        <h3>
          {{title}}
        </h3>
      </div>
      <div>
        <vs-row >
          <vs-col v-if="!partner_namespace" vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
            <label class="vs-input--label">Partner</label>
            <v-select
              v-model="form.partner_id"
              name="partner"
              v-validate="'required'"
              :class="errors.has('partner') ? 'danger':''"
              :options="partners.partners"
              :reduce="el => el.id" label="name"  />
            <span v-show="errors.has('partner')" class="text-danger">{{ errors.first('partner') }}</span>
          </vs-col>
          <vs-col  vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
            <vs-input
              v-model="form.model"
              type="text"
              name="model"
              v-validate="'required'"
              :danger="errors.has('model')"
              :danger-text="errors.has('model')? errors.first('model'):null"
              val-icon-danger="close"
              label="Model"
              placeholder=""
              style="width: 100%;"/>
          </vs-col>
          <vs-col  vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
            <vs-input
              v-model="form.brand"
              name="brand"
              v-validate="'required'"
              :danger="errors.has('brand')"
              :danger-text="errors.has('brand')? errors.first('brand'):null"
              type="text"
              val-icon-danger="close"
              label="Brand"
              placeholder=""
              style="width: 100%;"/>
          </vs-col>
          <vs-col  vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
            <vs-input
              v-model="form.plate"
              name="plate"
              v-validate="'required'"
              :danger="errors.has('plate')"
              :danger-text="errors.has('plate')? errors.first('plate'):null"
              type="text"
              val-icon-danger="close"
              label="Plate"
              placeholder=""
              style="width: 100%;"/>
          </vs-col>
          <vs-col  vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
            <vs-input
              v-model="form.eco_number"
              name="eco_number"
              v-validate="'required'"
              :danger="errors.has('eco_number')"
              :danger-text="errors.has('eco_number')? errors.first('eco_number'):null"
              type="text"
              val-icon-danger="close"
              label="Eco number"
              placeholder=""
              style="width: 100%;"/>
          </vs-col>
          <vs-col  vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
            <vs-input
              v-model="form.seats"
              name="seats"
              v-validate="'required|min_value:1'"
              :danger="errors.has('seats')"
              :danger-text="errors.has('seats')? errors.first('seats'):null"
              type="number"
              val-icon-danger="close"
              label="Seats"
              placeholder=""
              style="width: 100%;"/>
          </vs-col>
          <vs-col  vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
            <vs-input
              v-model="form.external_id"
              name="seats"
              v-validate="''"
              :danger="errors.has('external_id')"
              :danger-text="errors.has('external_id')? errors.first('external_id'):null"
              type="text"
              val-icon-danger="close"
              label="External id"
              placeholder=""
              style="width: 100%;"/>
          </vs-col>
          <vs-col vs-lg="12" vs-sm="12" vs-xs="12" style="padding:10px">
            <vs-checkbox v-model="form.is_active">Enabled</vs-checkbox>
          </vs-col>
        </vs-row>

        <vs-row>
          <vs-col vs-lg="6" vs-sm="6" vs-xs="12" style="padding:10px">
            <vs-button color="primary" @click="submit" type="filled">Save</vs-button>
          </vs-col>
        </vs-row>
      </div>
    </vs-card>
    <vs-card v-if="$route.params.id && false" class="cardx">
      <timeline :data="data_timeline" />
    </vs-card>
  </div>
</template>
<script>
  import {mapState, mapActions, mapGetters} from 'vuex';
  import moment from "moment";
  import Timeline from "../../components/charts/Timeline";

  export default {
    name :'EditVehicle',
    components: {
      'timeline': Timeline
    },
    data(){
      return {
        title : null,
        form:{
          partner_id : null,
          model : null,
          brand : null,
          plate : null,
          eco_number : null,
          seats: 1,
          is_active: true
        },
        errors_form : {
        },
        formRequired : {
          model : true,
          brand : true,
          plate : true,
          eco_number : true,
          seats: 0,
        },
        formValidation : {},
        onSubmit : false,
        data_timeline : []
      }
    },
    computed : {
      ...mapState(['partner_namespace']),
      ...mapGetters('users',['userCan']),
      ...mapState('partners',['partners']),
    },
    watch :{
      '$route.params.id': function (id) {
        this.initData();
      }
    },
    created() {
      this.initData();
    },
    methods: {
      ...mapActions('vehicles',['getVehicle','storeVehicle','updateVehicle']),
      initData(){
        if(this.$route.params.id){
          this.title = 'Edit vehicle';
          this.getVehicle({id: this.$route.params.id})
            .then(data=>{
              this.form = data;
              this.form.partner_id = data.partner.id;
            })
            .catch(error=>{
              //404
              if(error){
                if(error.status === 404){
                  //this.$router.push({name: 'page-error-404'});
                }
              }
            });
          this.getTimeline();
        }else{
          this.title = 'New vehicle';
          this.form = {
            partner_id : this.partner_namespace,
            model : null,
            brand : null,
            plate : null,
            eco_number : null,
            seats: 1,
            is_active: true
          };
        }
      },
      async submit(){
        let result = await this.$validator.validateAll();
        if (!result || this.onSubmit) {
          return;
        }

        if(this.$route.params.id){
          if(!this.userCan('vehicles.update')){
            this.$vs.notify({
              color: 'danger',
              title: `Error`,
              text: 'You need permission to perform this action',
            });
            return;
          }
          this.$vs.loading({
            type:'point',
          });
          this.onSubmit = true;

          let form = _.cloneDeep(this.form);
          delete form.partner;
          delete form.vehicle_type; 
          this.updateVehicle(form)
            .then(data=>{
              this.$vs.loading.close();
              this.onSubmit = false;
              this.msgDialog('success','Success','Vehicle successfully updated',this.redirectToVehicles);
            })
            .catch(error =>{
              this.$vs.loading.close();
              this.onSubmit = false;
              if(error){
                if(error.status === 409 || error.status === 400){
                  this.setErrors(error.data.errors);
                }else{
                    this.$vs.notify({
                      color: 'danger',
                      title: `Error`,
                      text: "There was an error. Please try again later.",
                    });
                }
              }
            })
        }else{
          if(!this.userCan('vehicles.create')){
            this.$vs.notify({
              color: 'danger',
              title: `Error`,
              text: 'You need permission to perform this action',
            });
            return;
          }
          this.$vs.loading({
            type:'point',
          });
          this.onSubmit = true;
          this.storeVehicle(this.form)
            .then(data=>{
              this.$vs.loading.close();
              this.onSubmit = false;
              this.msgDialog('success','Success','Vehicle successfully created',this.redirectToVehicles);
            })
            .catch(error =>{
              console.log(error);
              this.$vs.loading.close();
              this.onSubmit = false;
              if(error){
                if(error.status === 409 || error.status === 400){
                  this.setErrors(error.data.errors);
                }else{
                    this.$vs.notify({
                      color: 'danger',
                      title: `Error`,
                      text: "There was an error. Please try again later.",
                    });
                }
              }
            })
        }
      },
      setErrors(errors){
        for(let key in errors){
          if(Array.isArray(errors[key])){
            this.errors.add({
              field: key,
              msg: errors[key][0]
            });
          }
        }
      },
      msgDialog(color, title, text, action){
        this.$vs.dialog({
          color: color,
          title: title,
          text: text,
          accept:action
        })
      },
      redirectToVehicles(){
        if(this.partner_namespace){
          this.$router.push({name: 'partner.vehicles.list'});
        }else{
          this.$router.push({name: 'vehicles List'});
        }
      },
      getTimeline(){
        let data = [];

        let start = moment().startOf('day').add(5, 'hour');
        for(let i = 0; i<4; i++ ){
          start = start.add(1, 'hour');
          data.push( {
            "start": start.format('YYYY-MM-DD HH:mm:ss'),
            "end": start.add(1,'hour').format('YYYY-MM-DD HH:mm:ss'),
            "route": "Nombre de la ruta"
          });

          start = start.add(2, 'hour');
        }
        this.data_timeline = data;
      }
    }
  }
</script>
